import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Form, Input, Button, message} from "antd";
import {Row, Col, Alert} from "antd";
import {useTranslation} from "react-i18next";
import {UserOutlined} from "@ant-design/icons";
import Logo from "components/Logo/Logo.js";
import {Link} from "react-router-dom";

import {tutorAuthActions} from "_actions";

function TutorRecoverPasswordAsk(props) {
  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  var forgot = useSelector((state) => state.authReducer.forgot);
  var forgotError = useSelector((state) => state.authReducer.forgotError);

  useEffect(() => {
    setLoading(false);

    if (forgot) {
      setError(false);
      message.success(t("login.passwordSent"));
    }
    if (forgotError) {
      setError(true);
      setErrorMsg(t(forgotError.code));
    }
  }, [forgot, forgotError]);

  const onFinish = (values) => {
    setLoading(true);
    dispatch(tutorAuthActions.forgotPassword(values.email));
  };

  return (
    <>
      <Row justify="space-around" align="middle">
        <Col className="form-padding">
          <div style={{textAlign: "center"}}>
            <div className="logoh">
              <Logo menu={false} />
            </div>
          </div>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
          >
            <div style={{marginTop: 22, marginBottom: 22, paddingBottom: 12, paddingTop: 12}}></div>

            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  message: t("login.emailIncorrect"),
                },
                {
                  required: true,
                  message: t("login.emailMandatory"),
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon colorBlue" />}
                placeholder={t("login.email")}
              />
            </Form.Item>

            <Form.Item>
              <Link className="linkForgot moveRight" to="/auth/login">
                {t("login.login")}
              </Link>

              <Button type="primary" loading={loading} htmlType="submit" className="login-form-button">
                {t("login.recover")}
              </Button>
              {error && <Alert message={errorMsg} type="error" />}
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
}
export default withTranslation()(TutorRecoverPasswordAsk);
